import type { ParticipationAnswer } from '@cpce/shared';
import { commiteeQuery } from '@/api/queries.utils';
import { prestationsQueryKeys } from './prestations.query-keys';

export const participationAnswersQueryKey = (participationId: number) => [
  ...prestationsQueryKeys.participation(participationId),
  'answers',
];

export function useParticipationAnswers(participationId: number) {
  return commiteeQuery<ParticipationAnswer[]>({
    queryKey: participationAnswersQueryKey(participationId),
    url: `/commitee/:commiteeId/prestations/participations/${participationId}/answers`,
    enabled: participationId > 0,
  });
}
